exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".icon{position:relative;display:inline-block}.icon_image{display:block;margin:auto}", "", {"version":3,"sources":["/divvit-app/client/components/Icon/client/components/Icon/style.styl","/divvit-app/client/components/Icon/style.styl"],"names":[],"mappings":"AAAA,MACE,kBAAA,oBACA,CACA,YACE,cAAA,WACA,CCEH","file":"style.styl","sourcesContent":[".icon\n  position: relative\n  display: inline-block\n  &_image\n    display: block\n    margin: auto\n",".icon {\n  position: relative;\n  display: inline-block;\n}\n.icon_image {\n  display: block;\n  margin: auto;\n}\n/*# sourceMappingURL=client/components/Icon/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/components/Icon/style.styl
// module id = 396
// module chunks = 0